<template>
  <div>
    <unsaved-session-notify
      v-if="hasUnsavedSession"
      session-name="report"
      route-name-continue="reportEditStep2" />
    <project-table
      title="詳細表の一覧"
      :headers="headers"
      endpoint="/api/reports"
      @click:row="onEditClicked" />
    <global-footer>
      <template #left>
        <v-btn
          large
          @click.prevent="onReturnButtonClicked">
          <v-icon dark>mdi-chevron-left</v-icon>
          戻る
        </v-btn>
      </template>
    </global-footer>
    <unsaved-session-confirm
      v-if="confirmDialog"
      v-model="confirmDialog"
      session-name="report"
      route-name-continue="reportEditStep2"
      @clear="onClearSession"
      @cancel="confirmDialog=false" />
  </div>
</template>

<script>
import {
  hasUnsavedSession,
  removeStepSession,
  setStepObjectId,
  setStepSession,
} from '../../logic/session'
import ProjectTable from '../ProjectTable'
import UnsavedSessionConfirm from '../UnsavedSessionConfirm'
import UnsavedSessionNotify from '../UnsavedSessionNotifiy'

export default {
  name: 'ReportFormStep1',
  components: {
    UnsavedSessionNotify,
    ProjectTable,
    UnsavedSessionConfirm,
  },
  props: {
    headers: {
      type: Array,
      default: () => ([
        { value: 'report_approved', text: '承認ステータス', sortable: false },
        { value: 'title', text: '委託業務名/施設名', sortable: false },
        { value: 'block.name', text: 'ブロック', sortable: true },
        { value: 'created_user.name', text: '主任調査員', sortable: true },
        { value: 'approve_user_name', text: '協会審査員', sortable: false },
        { value: 'updated_at', text: '最終更新日', sortable: false },
        { value: 'created_at', text: '新規登録日', sortable: false },
        { value: 'report_download', text: '', sortable: false },
      ]),
    },
  },
  data() {
    return {
      confirmDialog: false,
      selectedItem: {},
    }
  },
  computed: {
    hasUnsavedSession() {
      return hasUnsavedSession('report')
    },
  },
  methods: {
    onEditClicked(item) {
      this.selectedItem = item
      // 未保存のデータがあれば確認ダイアログ。なければ正常遷移。
      if (this.hasUnsavedSession) {
        this.confirmDialog = true
      } else {
        this.onClearSession()
      }
    },
    async onClearSession() {
      const { id } = this.selectedItem
      // 更新されている可能性があるので再度読み込み
      const { data } = await window.axios.get(`/api/reports/${id}`)
      this.saveSessionFromItem(data)
      this.$router.push({
        name: 'reportEditStep2',
        params: { id },
      })
    },
    saveSessionFromItem(item) {
      // ステップ1の情報をセッションストレージに保存
      setStepSession('report', 1, item.id)

      const form1 = { ...item }
      const hasMaterialOtherText = form1.materials?.filter(
        material => !!material.pivot.other_text,
      ) ?? []
      if (hasMaterialOtherText.length > 0) {
        form1.material_other_text = hasMaterialOtherText[0].pivot.other_text
      }
      form1.materials = form1.materials?.map(({ pivot }) => pivot.material_id)
      setStepSession('report', 2, form1)
      setStepObjectId('report', `${item.id}`)
      removeStepSession('report', 3)
    },
    onReturnButtonClicked() {
      this.$router.push({ name: 'index' })
    },
  },
}
</script>
